module.exports = __webpack_public_path__ + "img/product5.ca8a614d.png";